import ObjectId from "bson-objectid";

export const copyItem = (item = {}, sectionIdReplacement = {}) => {
    const _id = new ObjectId().toHexString();
    const idReplacement = {
        ...sectionIdReplacement,
        [item._id]: _id
    };
    if (item._storage?._id) {
        idReplacement[item._storage._id] = _id;
    }

    const result = {
        ...item,
        _id
    };

    result.visible = updateConditionIds(result.visible, idReplacement);
    result.readOnly = updateConditionIds(result.readOnly, idReplacement);
    result.validation = updateConditionIds(result.validation, idReplacement);

    delete result._storage;
    delete result._dragging;

    return result;
};

export const copySection = (section = {}, sectionIdReplacement = {}) => {
    const _id = new ObjectId().toHexString();
    const idReplacement = {
        ...sectionIdReplacement,
        [section._id]: _id
    };
    if (section._storage?._id) {
        idReplacement[section._storage._id] = _id;
    }

    const result = {
        ...section,
        _id,
        items: section.items
            ? section.items.map((item) => copyItem(item, idReplacement))
            : []
    };

    result.visible = updateConditionIds(result.visible, idReplacement);
    result.readOnly = updateConditionIds(result.readOnly, idReplacement);

    delete result._storage;
    delete result._dragging;
    delete result.sharedSectionGroupingId;

    return result;
};

export const updateConditionIds = (orConditions = [], idReplacement) => {
    const updatedOrConditions = [];

    orConditions.forEach((andConditions = []) => {
        const updatedAndConditions = [];
        andConditions.forEach((andCondition) => {
            updatedAndConditions.push({
                ...andCondition,
                section: idReplacement[andCondition.section],
                item: idReplacement[andCondition.item],
                relativeSection: idReplacement[andCondition.relativeSection],
                relativeItem: idReplacement[andCondition.relativeItem]
            });
        });

        if (updatedAndConditions.length > 0) {
            updatedOrConditions.push(updatedAndConditions);
        }
    });

    return updatedOrConditions;
};
